import { IColumnValues, IKeyStringAndValue } from "../components/types/Types";

export default function dataMappingForFilters(dataList: {
  [key: string]: Array<IKeyStringAndValue>;
}) {
  /* Create datastructure for filters */
  const { data, categories } = Object.values(dataList)[0].reduce(
    (
      acc: { data: Array<IKeyStringAndValue>; categories: IColumnValues },
      currentItem: IKeyStringAndValue
    ) => {
      const keys = Object.keys(currentItem);

      // populate each category with its possible values
      keys.forEach((key) => {
        // make sure category exists
        if (acc.categories[key]) {
          // and value is not already present
          if (acc.categories[key].indexOf(currentItem[key]) === -1) {
            acc.categories[key].push(currentItem[key]);
          }
        } else {
          acc.categories[key] = [currentItem[key]];
        }
      });
      return acc;
    },
    { data: [], categories: {} }
  );
  return { data, categories };
}

export function dataMappingFargFilters(dataList: {
  [key: string]: Array<IKeyStringAndValue>;
}) {
  const { data, categories } = Object.values(dataList)[0].reduce(
    (
      acc: {
        data: Array<IKeyStringAndValue>;
        categories: IColumnValues;
      },
      currentItem: IKeyStringAndValue
    ) => {
      const keys = Object.keys(currentItem);
      acc.data.push(currentItem);
      acc.categories.omrade = ["Hela Sverige"];
      keys.forEach((key) => {
        // make sure category exists
        if (
          key === "boras" ||
          key === "alnarp" ||
          key === "uppsala" ||
          key === "vindeln"
        ) {
          acc.categories.omrade = [...acc.categories.omrade, key];
        }
      });
      return acc;
    },
    { data: [], categories: {} }
  );

  return { data, categories };
}
export function dataMappingPumpFilters(dataList: {
  [key: string]: Array<IKeyStringAndValue>;
}) {
  /* Create datastructure for filters */
  const { data, categories } = Object.values(dataList)[0].reduce(
    (
      acc: { data: Array<IKeyStringAndValue>; categories: IColumnValues },
      currentItem: IKeyStringAndValue
    ) => {
      const keys = Object.keys(currentItem);

      // populate each category with its possible values
      keys.forEach((key) => {
        // make sure category exists
        if (acc.categories[key]) {
          // and value is not already present
          if (acc.categories[key].indexOf(currentItem[key]) === -1) {
            acc.categories[key].push(currentItem[key]);
          }
        } else {
          acc.categories[key] = [currentItem[key]];
        }
      });
      acc.categories.typeOfPump = ["vv", "lv", "fl", "ll"];
      return acc;
    },
    { data: [], categories: {} }
  );
  return { data, categories };
}
